import { render, staticRenderFns } from "./shipment-open-report-totals.vue?vue&type=template&id=5879769e&scoped=true"
import script from "./shipment-open-report-totals.vue?vue&type=script&lang=js"
export * from "./shipment-open-report-totals.vue?vue&type=script&lang=js"
import style0 from "./shipment-open-report-totals.vue?vue&type=style&index=0&id=5879769e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879769e",
  null
  
)

export default component.exports